import { Button, Input } from 'antd';
import { FilterDropdownProps } from 'antd/es/table/interface';

export const customSearchFilterDropdownFactory =
  (placeholder?: string) =>
  ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: FilterDropdownProps) => (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        aria-label={placeholder}
        placeholder={placeholder}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
      />
      <div className="ant-table-filter-dropdown-btns" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={clearFilters} size="small" type="link" style={{ paddingLeft: 0 }}>
          Reset
        </Button>
        <Button type="primary" onClick={() => confirm()} size="small">
          OK
        </Button>
      </div>
    </div>
  );
